import { productIdFormat } from "@redotech/redo-product-id";
import * as z from "zod";

export const getSuppliesSubscribableProducts = {
  name: "getSuppliesSubscribableProducts" as const,
  input: z.object({}),
  output: z.object({
    products: z.array(
      z.object({
        suppliesProductId: productIdFormat.schema,
        title: z.string(),
        imageUrl: z.string().nullish(),
      }),
    ),
  }),
};
